<template>
  <div v-if="user">
    <!-- <button
      type="button"
      class="btn btn-outline-danger ml-1"
      data-toggle="modal"
      data-target="#userProfile"
    >
      <font-awesome-icon icon="id-badge" />
    </button> -->
    <div class="modal fade" id="userProfile">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              User ID:
              <span class="text-dark text-truncate">{{ user.email }}</span>
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <!-- .modal-header -->
          <div class="modal-body">
            <div class="pt-2">
              <span class="font-italic">Name:</span>
              <span v-if="user" class="h5 text-dark ml-1">{{
                user.display_name
              }}</span>
            </div>
            <div class="pt-2">
              <span class="font-italic">Email:</span>
              <span v-if="user" class="h5 text-dark ml-1">{{
                user.email
              }}</span>
            </div>
          </div>
          <!-- .modal-body -->

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
          <!-- .modal-footer -->
        </div>
        <!-- .modal-content -->
      </div>
      <!-- .modal-dialog .modal-lg-->
    </div>
    <!-- .modal fade -- End of userProfile -->
  </div>
</template>

<script>
// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  name: "olabuserprofile",
  props: ["user"],
  components: {
    // FontAwesomeIcon
  }
};
</script>
